import PapersNavigation from "./PapersNavigation";

export default PapersNavigation;
